module.exports = __webpack_public_path__ + "static/img/empty-illustration.12bb71c1.svg";